export var Route;
(function (Route) {
    Route["Home"] = "/";
    Route["Login"] = "/login";
    Route["Admins"] = "/admins";
    Route["Settings"] = "/settings";
    Route["Customers"] = "/customers";
    Route["ProductsGuide"] = "/products/guide";
    Route["Products"] = "/products";
    Route["PushNotifications"] = "/pushNotifications";
    Route["Wounds"] = "/wounds";
    Route["Medias"] = "/medias";
    Route["Models"] = "/models";
    Route["Hygienes"] = "/hygienes";
    Route["Vision"] = "/vision";
    Route["References"] = "/references";
    Route["Extras"] = "/extras";
})(Route || (Route = {}));
